import { useState } from "react";
import { Button, buttonVariants } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useConsumableFromSearchParam } from "@/common/api/use-consumable-from-search-param";
import { useCheckinConsumable } from "@/common/api/use-checkin-consumable";
import { Link } from "wouter";
import { Loader2 } from "lucide-react";

export function CheckinConsumableView() {
  const { selected, loading } = useConsumableFromSearchParam();
  const [qty, setQty] = useState<number>(1);

  const checkinMutation = useCheckinConsumable();

  const isLoading = checkinMutation.isPending;

  return (
    <main className="bg-background flex h-dvh items-start justify-center overflow-hidden px-4 pt-6">
      <div className="w-full max-w-sm space-y-6">
        <div className="space-y-1">
          <p className="text-muted-foreground text-xs font-medium tracking-widest uppercase">Einbuchen</p>
          <h1 className="text-foreground text-xl font-bold">Verbrauchsgegenstand</h1>
        </div>

        {loading && (
          <div className="flex justify-center py-8">
            <Loader2 className="text-muted-foreground h-6 w-6 animate-spin" />
          </div>
        )}

        {!loading && !selected && (
          <div className="border-border bg-card rounded-xl border p-6 text-center shadow-sm">
            <p className="text-muted-foreground text-sm">Kein Artikel ausgewählt.</p>
          </div>
        )}

        {!loading && selected && (
          <Card className="border-border shadow-sm">
            <CardHeader className="pb-2">
              <CardTitle className="text-foreground text-sm font-medium">{selected.name}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground text-xs">Kategorie</span>
                <span className="text-foreground text-sm">{selected.category?.name ?? "—"}</span>
              </div>
              <div className="bg-primary/10 text-primary rounded-lg px-4 py-3 text-sm font-medium">
                Bestand: {selected.qty}
              </div>
              <div className="space-y-1">
                <label className="text-muted-foreground text-xs font-medium">Anzahl einbuchen</label>
                <Input type="number" min={1} value={qty} onChange={(event) => setQty(Number(event.target.value))} />
              </div>
            </CardContent>
          </Card>
        )}

        <div className="flex items-center justify-between">
          <Link href="/consumables" className={buttonVariants({ variant: "secondary", size: "sm" })}>
            Zurück
          </Link>
          <Button
            size="sm"
            disabled={!selected || qty < 1 || isLoading}
            onClick={() => {
              if (!selected) return;
              checkinMutation.mutate({ consumableId: selected.id, newQty: selected.qty + qty });
            }}
          >
            {isLoading ? "Wird verarbeitet…" : "Einbuchen"}
          </Button>
        </div>
        {checkinMutation.isError && (
          <p className="text-destructive text-sm">
            {checkinMutation.error instanceof Error ? checkinMutation.error.message : "Unbekannter Fehler"}
          </p>
        )}
      </div>
    </main>
  );
}
